export default __webpack_public_path__ + "locales/es/EmbeddingPanel.json?hash=4e1a1fbc78f37c1bb88875913f5eac5f";